import React from "react";
import { MultiplesSectorsIcon } from "../../svgIcons";
export const NoResults = ({ noResults }) => (React.createElement("div", { className: "no-results" },
    MultiplesSectorsIcon({}),
    React.createElement("p", null, noResults)));
